import { render, staticRenderFns } from "./ShotHistoryModal.vue?vue&type=template&id=4b48238a&scoped=true&"
import script from "./ShotHistoryModal.vue?vue&type=script&lang=js&"
export * from "./ShotHistoryModal.vue?vue&type=script&lang=js&"
import style0 from "./ShotHistoryModal.vue?vue&type=style&index=0&id=4b48238a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b48238a",
  null
  
)

export default component.exports